<template>
  <b-button
    size="md"
    variant="link"
    :style="{ backgroundColor: '#08A762', color: '#ffffff' }"
    class="ml-3"
    @click="performAction"
  >
    <i class="fa fa-download" />
    Download labels
  </b-button>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { BButton } from 'bootstrap-vue-next'
import { computed, type ComputedRef, defineComponent } from 'vue'
import { useDownloadLabelsAction } from '@/composables/Labels/useDownloadLabelsAction'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'

export default defineComponent({
  name: 'DownloadLabels',
  components: { BButton },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const downloadLabelsAction = useDownloadLabelsAction()

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)

    const performAction = () => downloadLabelsAction([assignment.value])

    return {
      performAction,
    }
  },
})
</script>
